/**
 * <mqc-scroll-progress> — thin fixed bar at the top of the viewport that
 * fills as the user scrolls down the page. Purely cosmetic/premium-feel,
 * no dependency on prefers-reduced-motion since it reflects scroll
 * position rather than playing an animation.
 */
class MqcScrollProgress extends HTMLElement {
  connectedCallback() {
    this.#onScroll = this.#onScroll.bind(this);
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
  }

  #ticking = false;

  #onScroll() {
    if (this.#ticking) return;
    this.#ticking = true;

    requestAnimationFrame(() => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
      this.style.setProperty('--scroll-progress', progress.toFixed(2) + '%');
      this.#ticking = false;
    });
  }
}

if (!customElements.get('mqc-scroll-progress')) {
  customElements.define('mqc-scroll-progress', MqcScrollProgress);
}
